import { BaseNomenclatorModel } from './base.model';

export class TransportUnitTypeModel extends BaseNomenclatorModel {
    uid: string;
    name: string;
}
